import { supabase } from "./supabase";

export interface Workspace {
  id: string;
  name: string;
  default_engine: string;
  soniox_auto_delete: boolean;
}

let cached: Workspace | null = null;

/** Returns the user's default workspace (the one they own).
 * Phase 3 will replace this with a workspace switcher. */
export async function getDefaultWorkspace(): Promise<Workspace> {
  if (cached) return cached;
  const { data: user } = await supabase.auth.getUser();
  const uid = user.user?.id;
  if (!uid) throw new Error("not signed in");

  const { data, error } = await supabase
    .from("workspaces")
    .select("id, name, default_engine, soniox_auto_delete")
    .eq("owner_id", uid)
    .order("created_at", { ascending: true })
    .limit(1)
    .maybeSingle();
  if (error) throw error;
  if (!data) throw new Error("no workspace found for current user");
  cached = data as Workspace;
  return cached;
}

export function clearWorkspaceCache() {
  cached = null;
}
